export default Object.freeze({
  list: [],
  selectedClient: null,
  users: {},
  badges: {},
  clientEmailSettings: {},
  siteEmailSettings: {},
  mobilePatrolEmailSettings: {},
});
